import "intersection-observer";
import { useEffect, useState, useCallback } from "react";

var isFunction = function (value) {
  return typeof value === "function";
};

export var getTargetElement = function (target) {
  if (!target) {
    return null;
  }

  var targetElement;

  if (isFunction(target)) {
    targetElement = target();
  } else if ("current" in target) {
    targetElement = target.current;
  } else {
    targetElement = target;
  }

  return targetElement;
};

var useIntersectionObserver = function () {
  var _a = useState(null),
      observerEntry = _a[0],
      setObserverEntry = _a[1];

  var _b = useState(null),
      observe = _b[0],
      setObserver = _b[1];

  var handle = useCallback(function (entries) {
    for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
      var entry = entries_1[_i];
      setObserverEntry(entry);
    }
  }, []);
  var listen = useCallback(function (_a) {
    var rootMargin = _a.rootMargin,
        threshold = _a.threshold,
        root = _a.root,
        element = _a.element;
    var options = {
      rootMargin: rootMargin,
      root: getTargetElement(root),
      threshold: threshold
    };
    var observer = new IntersectionObserver(function (entries) {
      handle === null || handle === void 0 ? void 0 : handle(entries);
    }, options);

    if (element) {
      observer.observe(element);
      setObserver(observer);
    }
  }, []);
  useEffect(function () {
    return function () {
      var _a;

      (_a = observe === null || observe === void 0 ? void 0 : observe.disconnect) === null || _a === void 0 ? void 0 : _a.call(observe);
      handle = null;
    };
  }, []);
  return [observerEntry, listen];
};

export { useIntersectionObserver };